import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'

const toast = {
    error: (message, title = 'Error') => {
        return iZtoast.error({
            timeout: 3000,
            progressBar: false,
            title: title,
            message: message,
            displayMode: 2,
            position: 'bottomCenter'
        });
    },
    warning: (message, title = 'Warning') => {
        return iZtoast.warning({
            timeout: false,
            progressBar: false,
            title: title,
            message: message,
            displayMode: 2,
            close: true,
            position: 'bottomCenter'
        });
    },
    permanentWarning: (message, title = 'Warning') => {
        return iZtoast.warning({
            class: 'csm-perma-toast',
            timeout: false,
            progressBar: false,
            title: title,
            message: message,
            displayMode: 2,
            close: false,
            position: 'bottomLeft'
        });
    },
    success: (message, title = 'Success', timeout = 5000) => {
        return iZtoast.success({
            timeout: timeout,
            progressBar: false,
            title: title,
            message: message,
            position: 'bottomCenter'
        });
    },
    info: (message, title = 'Info', customClass = 'csm-loader') => {
        return iZtoast.info({
            progressBar: false,
            title: title,
            message: message,
            class: customClass,
            timeout: 3000,
            displayMode: 2,
            position: "bottomCenter"
        })
    },
    infoTop: (message, title = 'Info', customClass = 'csm-loader') => {
        return iZtoast.info({
            progressBar: false,
            title: title,
            message: message,
            class: customClass,
            timeout: 10000,
            displayMode: 2,
            position: "topCenter"
        })
    },


    hide: (customClass = 'csm-loader') => {
        let toast = document.querySelector('.iziToast');
        if(toast) {
            iZtoast.hide({}, toast);
        }
    }
};

export default toast;